import { MealType } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { CheckboxGroupField } from "@/components/ui/form/fields/check-box-field/check-box-group";

type Props = {
	isEdited: boolean;
	hasError: boolean;
	error: string | undefined;
	rawIncludedMeals: MealType[];
	onToggleMeal: (mealType: MealType) => void;
};

const MEAL_OPTIONS: FormOptionType[] = [
	{ id: MealType.Breakfast, label: "朝食付き", value: MealType.Breakfast },
	{ id: MealType.Lunch, label: "昼食付き", value: MealType.Lunch },
	{ id: MealType.Dinner, label: "夕食付き", value: MealType.Dinner },
	{ id: MealType.RoomOnly, label: "素泊まり（食事なし）", value: MealType.RoomOnly },
];

export const QuestionPlanMealConditions = ({ isEdited, hasError, error, rawIncludedMeals, onToggleMeal }: Props) => {
	const label = "食事の提供";
	const guide = "プランに含まれる食事を設定できます。食事を設定することで予約ページに表示されます。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={label}
			guide={guide}
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<CheckboxGroupField
					value={rawIncludedMeals}
					options={MEAL_OPTIONS}
					handleCheckedChange={(_checked, item) => onToggleMeal(item.value as MealType)}
					gridCols={2}
					errorMessage={error}
				/>
			}
		/>
	);
};

QuestionPlanMealConditions.displayName = "QuestionPlanMealConditions";
